import React, {FC} from "react";
import {
  excelExtensions,
  fileColors,
  imageExtensions,
  mediaExtensions,
} from "constraints/general";
import ImageIcon from "view/images/ImageIcon";
import FileIconImage from "view/images/FileIcon";
import {UnpackedAttachmentFile} from "ts/api/attachmentFile";
import ExcelIcon from "view/images/ExcelIcon";
import MediaIcon from "view/images/MediaIcon";

const FileIcon: FC<{
  extension: UnpackedAttachmentFile["extension"];
  isPDF?: boolean;
}> = ({extension}) => {
  if (mediaExtensions.includes(extension)) {
    return <MediaIcon />;
  }
  if (imageExtensions.includes(extension)) {
    return <ImageIcon color={fileColors[extension]} />;
  }
  if (excelExtensions.includes(extension)) {
    return <ExcelIcon />;
  }
  return <FileIconImage color={fileColors[extension]} />;
};

export default FileIcon;
